import React from 'react'

// material-ui
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Container from '@mui/material/Container'
import Link from '@mui/material/Link'

// components
import DesktopLogoHeader from 'components/shared/LogoHeader/DesktopHeader'

const DesktopHeader = props => {
  const { account, title } = props

  return (
    <>
      <DesktopLogoHeader title={title} />
      {account && (
        <Container>
          <Box displayPrint='none'>
            <Typography variant='body1' align='right'>
              Hi, {account.user.firstName}
              {' | '}
              <Link href='/logout'>Log Out</Link>
            </Typography>
          </Box>
        </Container>
      )}
    </>
  )
}

export default DesktopHeader
